import { apiBaseUrl } from "~/modules/Router/Auth/constant";
import { fetchAdapter } from "~/utils/fetch";
import { ErrorTypes, ResultType } from "../../types";
import { TDao } from "../../../../../_types/TDao";

export const getDaoInfo = async (params: {
  subdomain: string;
}): Promise<ResultType<TDao, ErrorTypes>> => {
  try {
    const urlSearchParams = new URLSearchParams();
    urlSearchParams.append(
      encodeURIComponent(`subdomain`),
      encodeURIComponent(params.subdomain),
    );
    const url = `${apiBaseUrl}/daos?${urlSearchParams.toString()}`;

    const fetchResult = await fetchAdapter(url, {
      method: `GET`,
      credentials: `include`,
      referrerPolicy: `no-referrer-when-downgrade`,
    })
      .then((res) => {
        return { ok: true as const, value: res };
      })
      .catch(() => {
        return {
          ok: false as const,
          value: ErrorTypes.UnCategorizedError,
        };
      });
    if (!fetchResult.ok) {
      return fetchResult;
    }
    const { value: res } = fetchResult;

    if (res.status !== 200) {
      return {
        ok: false,
        value: ErrorTypes.UnCategorizedError,
      };
    }

    const json = await res.json();
    if (json?.code !== `000`) {
      return {
        ok: false,
        value: ErrorTypes.UnCategorizedError,
      };
    }

    const daoInfo =
      (json.data as Array<TDao>).find((a) => {
        return a.subdomain === params.subdomain;
      }) ?? null;
    if (daoInfo == null) {
      return {
        ok: false,
        value: ErrorTypes.NotExistingDaoError,
      };
    }

    return {
      ok: true,
      value: daoInfo,
    };
  } catch (error) {
    return {
      ok: false,
      value: ErrorTypes.UnCategorizedError,
    };
  }
};
